import React, { useEffect, useState } from 'react'
import TimeCountSelector from '@ui/selects/TimeCountSelector'

export default function Playground() {
  const [data, setData] = useState<any>({ days: 2 })

  useEffect(() => console.log(data), [data])

  return (
    <TimeCountSelector
      value={data}
      onChange={setData}
      maximums={{ days: 180, weeks: 26, months: 6 }}
    />
  )
}
